import { Box, styled } from '@mui/material';

export const SapCollateralChangeRoot = styled(Box)`
  /* 공통 표의 break-all 보다 우선해야 영문 머리글이 단어 중간에서 안 끊김 */
  & .approval-form-table th {
    word-break: keep-all;
  }
`;
